// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"7dd3a89d","138":"ec286624","528":"0cf39ade","671":"0a98feda","914":"a1f21080"}[chunkId] + ".chunk.js";
};